import HttpService from '@/endpoints/HttpService';
import HttpResponse from '@/interfaces/HttpResponse';
import { ProjectPatchOperation, ProjectSettingsPatchRequest } from '@/models/project/projectApiInterfaces';
import { ProjectSettingsResponse } from '@/models/project/projectSettings';

const projectSettingsUrl = `${process.env.VUE_APP_API_PREFIX}projectSettings`;

export default class ProjectSettingsService {
  public static async patchProjectSettings(
    operation: ProjectPatchOperation
  ): Promise<HttpResponse<ProjectSettingsResponse>> {
    const isAppliedToAllRooms = !!operation.applyToAllRooms;
    const body: ProjectSettingsPatchRequest = {
      patch: operation.operations,
      isAppliedToAllRooms,
      roomIds: isAppliedToAllRooms ? undefined : operation.roomIds,
    };
    return await HttpService.patchWithLoading(`${projectSettingsUrl}/${operation.projectId}`, body);
  }
}
